export const devextremeLocalisation = {
  'en-CA': {
    'Loading': 'Loading...',
    'Select': 'Select...',
    'Cancel': 'Cancel',
    'dxList-selectAll': 'Select All',
    'dxDataGrid-noDataText': 'No data',
    'dxDataGrid-filterRowShowAllText': '(All)',
    'dxDataGrid-trueText': 'Yes',
    'dxDataGrid-falseText': 'No',
    'dxDataGrid-filterRowOperationStartsWith': 'Starts with',
    'dxDataGrid-filterRowOperationContains': 'Contains',
    'dxDataGrid-filterRowOperationNotContains': 'Does not contain',
    'dxDataGrid-filterRowOperationEndsWith': 'Ends with',
    'dxDataGrid-filterRowOperationEquals': 'Equals',
    'dxDataGrid-filterRowOperationNotEquals': 'Does not equal',
    'dxDataGrid-filterRowResetOperationText': 'Reset',
    'dxDataGrid-filterRowOperationLess': 'Less than',
    'dxDataGrid-filterRowOperationLessOrEquals': 'Less than or equal to',
    'dxDataGrid-filterRowOperationGreater': 'Greater than',
    'dxDataGrid-filterRowOperationGreaterOrEquals': 'Greater than or equal to',
    'dxDataGrid-filterRowOperationBetween': 'Between',
    'dxDataGrid-filterRowOperationBetweenStartText': 'Start',
    'dxDataGrid-filterRowOperationBetweenEndText': 'End',
    'dxFileUploader-selectFile': 'Select file',
    'dxFileUploader-dropFile': 'or Drop file here',
    'dxFileUploader-bytes': 'bytes',
    'dxFileUploader-kb': 'kb',
    'dxFileUploader-Mb': 'Mb',
    'dxFileUploader-Gb': 'Gb',
    'dxFileUploader-upload': 'Upload',
    'dxFileUploader-uploaded': 'Uploaded',
    'dxFileUploader-readyToUpload': 'Ready to upload',
    'dxFileUploader-uploadFailedMessage': 'Upload failed',
    'dxFileUploader-invalidFileExtension': 'File type is not allowed',
    'dxFileUploader-invalidMaxFileSize': 'File is too large',
    'dxFileUploader-invalidMinFileSize': 'File is too small',
    'validation-range': ''
  },
  'fr-CA': {
    'Loading': 'Chargement...',
    'Select': 'Sélectionner...',
    'Cancel': 'Annuler',
    'dxList-selectAll': 'Tout sélectionner',
    'dxDataGrid-noDataText': 'Pas de données',
    'dxDataGrid-filterRowShowAllText': '(Tout)',
    'dxDataGrid-trueText': 'Oui',
    'dxDataGrid-falseText': 'Non',
    'dxDataGrid-filterRowOperationStartsWith': 'Commence avec',
    'dxDataGrid-filterRowOperationContains': 'Contient',
    'dxDataGrid-filterRowOperationNotContains': 'Ne contient pas',
    'dxDataGrid-filterRowOperationEndsWith': 'Se termine par',
    'dxDataGrid-filterRowOperationEquals': 'Est égal',
    'dxDataGrid-filterRowOperationNotEquals': 'N\'est pas égal',
    'dxDataGrid-filterRowResetOperationText': 'Réinitialiser',
    'dxDataGrid-filterRowOperationLess': 'Moins que',
    'dxDataGrid-filterRowOperationLessOrEquals': 'Moins que ou égal à',
    'dxDataGrid-filterRowOperationGreater': 'Plus grand que',
    'dxDataGrid-filterRowOperationGreaterOrEquals': 'Plus grand que ou égal à',
    'dxDataGrid-filterRowOperationBetween': 'Entre',
    'dxDataGrid-filterRowOperationBetweenStartText': 'Début',
    'dxDataGrid-filterRowOperationBetweenEndText': 'Fin',
    'dxFileUploader-selectFile': 'Choisissez un fichier',
    'dxFileUploader-dropFile': 'Enlever fichier',
    'dxFileUploader-bytes': 'Bytes',
    'dxFileUploader-kb': 'kb',
    'dxFileUploader-Mb': 'Mb',
    'dxFileUploader-Gb': 'Gb',
    'dxFileUploader-upload': 'Télécharger',
    'dxFileUploader-uploaded': 'Téléchargé',
    'dxFileUploader-readyToUpload': 'Pret à télécharger',
    'dxFileUploader-uploadFailedMessage': 'Echec du téléchargement',
    'dxFileUploader-invalidFileExtension': 'Type de fichier non autorisé',
    'dxFileUploader-invalidMaxFileSize': 'Fichier trop volumineux',
    'dxFileUploader-invalidMinFileSize': 'Fichier trop petit',
    'validation-range': ''
  },
  'es-ES': {
    'Loading': 'Loading...',
    'Select': 'Select...',
    'Cancel': 'Cancel',
    'dxList-selectAll': 'Select All',
    'dxDataGrid-noDataText': 'No data',
    'dxDataGrid-filterRowShowAllText': '(All)',
    'dxDataGrid-trueText': 'Yes',
    'dxDataGrid-falseText': 'No',
    'dxDataGrid-filterRowOperationStartsWith': 'Starts with',
    'dxDataGrid-filterRowOperationContains': 'Contains',
    'dxDataGrid-filterRowOperationNotContains': 'Does not contain',
    'dxDataGrid-filterRowOperationEndsWith': 'Ends with',
    'dxDataGrid-filterRowOperationEquals': 'Equals',
    'dxDataGrid-filterRowOperationNotEquals': 'Does not equal',
    'dxDataGrid-filterRowResetOperationText': 'Reset',
    'dxDataGrid-filterRowOperationLess': 'Less than',
    'dxDataGrid-filterRowOperationLessOrEquals': 'Less than or equal to',
    'dxDataGrid-filterRowOperationGreater': 'Greater than',
    'dxDataGrid-filterRowOperationGreaterOrEquals': 'Greater than or equal to',
    'dxDataGrid-filterRowOperationBetween': 'Between',
    'dxDataGrid-filterRowOperationBetweenStartText': 'Start',
    'dxDataGrid-filterRowOperationBetweenEndText': 'End',
    'dxFileUploader-selectFile': 'Select file',
    'dxFileUploader-dropFile': 'or Drop file here',
    'dxFileUploader-bytes': 'bytes',
    'dxFileUploader-kb': 'kb',
    'dxFileUploader-Mb': 'Mb',
    'dxFileUploader-Gb': 'Gb',
    'dxFileUploader-upload': 'Upload',
    'dxFileUploader-uploaded': 'Uploaded',
    'dxFileUploader-readyToUpload': 'Ready to upload',
    'dxFileUploader-uploadFailedMessage': 'Upload failed',
    'dxFileUploader-invalidFileExtension': 'File type is not allowed',
    'dxFileUploader-invalidMaxFileSize': 'File is too large',
    'dxFileUploader-invalidMinFileSize': 'File is too small',
    'validation-range': ''
  },
  'de-DE': {
    'Loading': 'Loading...',
    'Select': 'Select...',
    'Cancel': 'Cancel',
    'dxList-selectAll': 'Select All',
    'dxDataGrid-noDataText': 'No data',
    'dxDataGrid-filterRowShowAllText': '(All)',
    'dxDataGrid-trueText': 'Yes',
    'dxDataGrid-falseText': 'No',
    'dxDataGrid-filterRowOperationStartsWith': 'Starts with',
    'dxDataGrid-filterRowOperationContains': 'Contains',
    'dxDataGrid-filterRowOperationNotContains': 'Does not contain',
    'dxDataGrid-filterRowOperationEndsWith': 'Ends with',
    'dxDataGrid-filterRowOperationEquals': 'Equals',
    'dxDataGrid-filterRowOperationNotEquals': 'Does not equal',
    'dxDataGrid-filterRowResetOperationText': 'Reset',
    'dxDataGrid-filterRowOperationLess': 'Less than',
    'dxDataGrid-filterRowOperationLessOrEquals': 'Less than or equal to',
    'dxDataGrid-filterRowOperationGreater': 'Greater than',
    'dxDataGrid-filterRowOperationGreaterOrEquals': 'Greater than or equal to',
    'dxDataGrid-filterRowOperationBetween': 'Between',
    'dxDataGrid-filterRowOperationBetweenStartText': 'Start',
    'dxDataGrid-filterRowOperationBetweenEndText': 'End',
    'dxFileUploader-selectFile': 'Select file',
    'dxFileUploader-dropFile': 'or Drop file here',
    'dxFileUploader-bytes': 'bytes',
    'dxFileUploader-kb': 'kb',
    'dxFileUploader-Mb': 'Mb',
    'dxFileUploader-Gb': 'Gb',
    'dxFileUploader-upload': 'Upload',
    'dxFileUploader-uploaded': 'Uploaded',
    'dxFileUploader-readyToUpload': 'Ready to upload',
    'dxFileUploader-uploadFailedMessage': 'Upload failed',
    'dxFileUploader-invalidFileExtension': 'File type is not allowed',
    'dxFileUploader-invalidMaxFileSize': 'File is too large',
    'dxFileUploader-invalidMinFileSize': 'File is too small',
    'validation-range': ''
  },
};
